// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"132":"8c7de76ac6a52e15","888":"4143381f8bdf8fd9"}[chunkId] + ".css";
};